<style lang="less" scoped>

</style>

<template lang="pug">
  #order.admin-container
    .admin-title-cover
      .admin-title 회원 관리
    .admin-content-cover
      .order-list-cover
        el-table(:data="users", style="width: 100%")
          el-table-column(label="승인여부", width="100")
            template(slot-scope="scope")
              router-link(:to="`/admin/members/${scope.row._id}`") {{ scope.row.isAccepted ? '승인' : '대기' }}
          el-table-column(label="유형", width="100")
            template(slot-scope="scope") {{ userTypeMap[scope.row._id] }}
          el-table-column(prop="name", label="이름")
          el-table-column(prop="email", label="이메일")
          el-table-column(label="가입일")
            template(slot-scope="scope") {{ scope.row.created | dateFilter }}
</template>

<script>
import moment from 'moment';

moment.locale('ko');

export default {
  filters: {
    dateFilter(date) {
      return moment(date).format('lll');
    },
  },
  computed: {
    userTypeMap() {
      if (!this.users) return null;
      const map = {};
      this.users.forEach((user) => {
        if (user.type === 'doctor') map[user._id] = '사업자';
        else map[user._id] = '학생';
      });
      return map;
    },
  },
  data() {
    return {
      users: null,
    };
  },
  async mounted() {
    const { data } = await this.$http.get('/users');
    this.users = data;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/member.vue